import type { FieldValues } from 'react-hook-form';

// https://github.com/react-hook-form/react-hook-form/discussions/1991
export const getFormDirtyValues = (
    dirtyFields: FieldValues | boolean,
    allValues: FieldValues
): FieldValues => {
    // NOTE: Recursive function.

    // If *any* item in an array was modified, the entire array must be submitted, because there's no
    // way to indicate "placeholders" for unchanged elements. `dirtyFields` is `true` for leaves.
    if (dirtyFields === true || Array.isArray(dirtyFields)) {
        return allValues;
    }

    // Here, we have an object.
    return Object.fromEntries(
        Object.keys(dirtyFields).map((key) => [
            key,
            // @ts-ignore - inspired by https://github.com/react-hook-form/react-hook-form/discussions/1991
            getFormDirtyValues(dirtyFields[key], allValues[key]),
        ])
    );
};
